export const VALIDATE_IP_ADDRESS = 'VALIDATE_IP_ADDRESS'
export const VALIDATE_TOKEN_ACCOUNT = 'VALIDATE_TOKEN_ACCOUNT'
export const VALIDATE_USER_VERIFICATION = 'VALIDATE_USER_VERIFICATION'
